// Shared survey status pill — used by BOTH the global Survey page and the
// project Survey tab so the status coloring stays consistent across surfaces
// (mirrors the receiving/statusBadge pattern). Single source of truth for the
// Submitted/Scheduled/In Progress/Complete/Canceled colors.

export const SURVEY_STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  'Submitted':   { bg: '#E1EEF7', text: '#0D4C7C' },
  'Scheduled':   { bg: '#FEF3C7', text: '#92400E' },
  'In Progress': { bg: '#E6F2EB', text: '#015A28' },
  'Complete':    { bg: '#EDEDEC', text: '#454543' },
  'Canceled':    { bg: '#FBE4DF', text: '#8F2414' },
};

export function SurveyStatusBadge({ label }: { label: string }) {
  const c = SURVEY_STATUS_COLORS[label] ?? { bg: '#f3f4f6', text: '#6b7280' };
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px', borderRadius: 'var(--ew-r-sm)', fontSize: 11, fontWeight: 600,
      background: c.bg, color: c.text, letterSpacing: '0.04em', textTransform: 'uppercase', whiteSpace: 'nowrap',
    }}>
      {label}
    </span>
  );
}
